module.exports = __webpack_public_path__ + "img/vertical_2_1_9016.00851019.png";